import { getData } from "../helpers";
import { PaymentmethodModal } from "../views/settings/settings/paymentmethods/modals/store";

class ButtonPaymentmethod extends HTMLButtonElement {
    connectedCallback() {
        this.test();
        this.load();
        this.events();
    }

    test() {
        // No borrar este método, pero sí su contenido
    }

    load() {
        //
    }

    events() {
        this.addEventListener("click", (e) => {
            PaymentmethodModal.create(
                getData(this, "data-bs-target"),
                getData(this, "title"),
                getData(this, "data-url"),
                getData(this, "data-message")
            );
        });
    }
}

window.customElements.define("button-paymentmethod", ButtonPaymentmethod, {
    extends: "button",
});
